import {
  ExternalManagementActionTypes,
  ExternalManagementActions,
} from './external-users-management.actions';
import { IExternalData, IPending } from '../../../commons';

export interface State {
  error: string | null;
  pending: IPending;
  stateData: IExternalData[] | null;
}

export const initialState: State = {
  error: null,
  pending: {
    pending: false,
    pendingMessage: ''
    },
  stateData: null,
};

export function reducer(
  state = initialState,
  action: ExternalManagementActions
): State {
  switch (action.type) {
    case ExternalManagementActionTypes.LoadExternalManagementState: {
      return {
        ...state,
        // error: null,
        pending: {
          pending: true,
          pendingMessage: 'Loading External Users...',
        },
      };
    }

    case ExternalManagementActionTypes.LoadExternalManagementStateSuccess: {
      return {
        ...state,
        pending: {
            pendingMessage: '',    
            pending: false
        },
        stateData: action.payload,
      };
    }

    case ExternalManagementActionTypes.LoadExternalManagementStateFail: {
      return {
        ...state,
        error: action.payload,
        pending: {
            pendingMessage: '',    
            pending: false,
        },
      };
    }

    case ExternalManagementActionTypes.ExternalManagementScreenErrorReset: {
      return {
        ...state,
        error: null,
        pending: {
            pendingMessage: '',    
            pending: false,
        },
      };
    }

    case ExternalManagementActionTypes.ApproveUser: {
      return {
        ...state,
        error: null,
        pending: {
          pending: true,
          pendingMessage: 'Approving User ...',
        },
      };
    }

    case ExternalManagementActionTypes.ApproveUserFailed: {
      return {
        ...state,
        error: action.payload,
        pending: {
          pending: false,
          pendingMessage: action.payload,
        },
      };
    }

    case ExternalManagementActionTypes.ApproveUserSuccess: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case ExternalManagementActionTypes.RejectUser: {
      return {
        ...state,
        error: null,
        pending: {
          pending: true,
          pendingMessage: 'Rejecting User ...',
        },
      };
    }

    case ExternalManagementActionTypes.RejectUserFailed: {
      return {
        ...state,
        error: action.payload,
        pending: {     
            pendingMessage: '',    
            pending: false
        }
      };
    }

    case ExternalManagementActionTypes.RejectUserSuccess: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case ExternalManagementActionTypes.CharityCheckState: {
      return {
        ...state,
        pending: {
          pending: true,
          pendingMessage: 'Verifying EIN via GuideStar ...',
        },
      };
    }

    case ExternalManagementActionTypes.CharityCheckStateFail: {
      return {
        ...state,
        error: action.errorMessage,
        pending: {
            pendingMessage: '',    
            pending: false,}
      };
    }

    case ExternalManagementActionTypes.CharityCheckStateSuccess: {
      return {
        ...state,
        pending: {
          pending: false,
          pendingMessage: action.message,
        },
      };
    }

    case ExternalManagementActionTypes.AddExceptionEINState: {
      return {
        ...state,
        pending: {
          pending: true,
          pendingMessage: 'Adding Organization Info into EIN Exception ...',
        },
      };
    }

    case ExternalManagementActionTypes.AddExceptionEINStateFail: {
      return {
        ...state,
        error: action.errorMessage,
        pending: { 
            pendingMessage: '',    
            pending: false 
        },
      };
    }

    case ExternalManagementActionTypes.AddExceptionEINStateSuccess: {
      return {
        ...state,
        pending: { pending: false, pendingMessage: '' },
      };
    }

    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;
